<div class="grid grid-cols-1 md:grid-cols-2 gap-4" role="radiogroup">
    <ng-content></ng-content>
</div>
